import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { Spinner } from '../../common';
import { PublisherApi } from '../../../api';
import { findPredicate, findComparator } from '../../../utils/helpers/filter_conversions';
import { humanize } from '../../../utils/helpers/text_formatters';

class Payments extends Component {
  
  componentDidMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { dispatch } = this.props;
    dispatch(PublisherApi.actions.payments.get(params));  
  }

  handleOnFilterChange(e) {
    const filters = get(this.props, 'payments.meta.filters', {});
    Object.entries(e).forEach(([field, properties]) => {
      switch (properties.type) {
        case 'NumberFilter': {
          const { value: { comparator, number } } = properties;
          filters[field] = { value: number, predicate: findPredicate(comparator) };
          break;
        }
        case 'DateFilter': {
          const { value: { comparator, date } } = properties;
          filters[field] = { value: date, predicate: findPredicate(comparator) };
          break;
        }
        default:
          break;
      }
    });
    
    this.fetchResource({
      page: get(this.props, 'payments.meta.pagination.page', 1),
      per_page: get(this.props, 'payments.meta.pagination.page', 10),
      filters,
      sort: get(this.props, 'payments.meta.sort', {})
    });
  }

  handleOnSortChange(field, order) {
    const sort = { field, order };
    this.fetchResource({
      page: get(this.props, 'payments.meta.pagination.page', 1),
      per_page: get(this.props, 'payments.meta.pagination.page', 10),
      filters: get(this.props, 'payments.meta.filters', {}),
      sort
    });
  }

  handleOnPageChange(page, per_page) {
    this.fetchResource({
      page,
      per_page,
      filters: get(this.props, 'payments.meta.filters', {}),
      sort: get(this.props, 'payments.meta.sort', {})
    });
  }

  handleDateApply(d) {
    const filters = get(this.props, 'payments.meta.filters', {});
    
    filters.daterange = {
      start_date: { value: d.startDate.format() },
      end_date: { value: d.endDate.format() }
    };

    this.fetchResource({
      page: get(this.props, 'payments.meta.pagination.page', 1),
      per_page: get(this.props, 'payments.meta.pagination.page', 10),
      filters,
      sort: get(this.props, 'payments.meta.sort', {})
    });
  }

  generateFilter(dataField) {
    const { value, predicate } = get(this.props, `payments.meta.filters.${dataField}`, {});
    let filter = {};
    switch (dataField) {
      case 'amount': {
        filter.type = 'NumberFilter';
        filter.numberComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) { 
          filter.defaultValue = { 
            number: parseInt(value, 10), 
            comparator: findComparator(predicate) 
          };
        }
        break;
      }
      case 'date': {
        filter.type = 'DateFilter';
        filter.dateComparators = ['>', '<'];
        filter.defaultValue = {};
        if (value && predicate) {
          filter.defaultValue = { date: value, comparator: findComparator(predicate) };
        }
        break;
      }
      default:
        filter = {};
    }
    return filter;
  }

  render() {
    const { payments, isLoading } = this.props;
    const { data, meta } = payments || {};
    const { pagination, sort } = meta || {};
    
    const options = {
      onFilterChange: this.handleOnFilterChange.bind(this),
      onSortChange: this.handleOnSortChange.bind(this),
      sortName: get(sort, 'field', 'date'),
      sortOrder: get(sort, 'order', 'desc'),
      defaultSortName: get(sort, 'field', 'date'),
      defaultSortOrder: get(sort, 'order', 'desc'),
      sizePerPage: get(pagination, 'per_page', 10),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1)
    };

    const fetchInfo = {
      dataTotalSize: get(pagination, 'total_count', 0)
    };

    return (
          <div className={`spinkit${isLoading ? ' sk-loading' : ''}`}>
              <Spinner />
              <BootstrapTable
                ref='PaymentsTable' 
                data={data || []} 
                remote 
                pagination
                fetchInfo={fetchInfo}
                options={options}
              >
                <TableHeaderColumn 
                  width='145'
                  dataSort
                  filter={this.generateFilter('date')}
                  dataField='date'
                  dataFormat={(c) => moment(c).local().format('MMMM[,] YYYY')}
                >
                  Month
                </TableHeaderColumn>

                <TableHeaderColumn 
                  width='145'
                  dataSort 
                  dataField='amount' 
                  filter={this.generateFilter('amount')}
                  dataFormat={(c) => c}
                >
                  $ Amount
                </TableHeaderColumn>
                
                <TableHeaderColumn 
                  width='145'
                  dataSort
                  dataField='status'
                  dataFormat={(c) => humanize(c)}
                >
                  Status
                </TableHeaderColumn>

                <TableHeaderColumn 
                  isKey
                  hidden
                  width='0'
                  dataField='uuid'
                />   

              </BootstrapTable>
          </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { publisher } = state;
  return { payments: publisher.payments.data, isLoading: publisher.payments.loading };
};

export default connect(mapStateToProps)(Payments);
